// in ./ResetViewsButton.js
import * as React from "react";
import { Link } from 'react-router-dom';
import {
    Button,
} from 'react-admin';
import JobIcon from '@mui/icons-material/Assignment';

const ButtonCreateJob = ({ selectedIds, label }) => {
    // const unselectAll = useUnselectAll('hydrants');
    console.log(`selectedIds: ${selectedIds}`);
    return (      
      <Button
        component={Link}
        label='Create OTA Job'
        to={`/jobs/create?id=${selectedIds}`}
      >
          <JobIcon />
      </Button>
    );
};

export default ButtonCreateJob;